<template>
  <v-row>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon :color="data.color" dark v-on="on" style="cursor: help;">{{data.icon}}</v-icon>
      </template>
      <span>{{data.tooltip}}</span>
    </v-tooltip>
  </v-row>
</template>

<script>
export default {
  name: "IconTooltip",
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          color: "error",
          tooltip: "no-data",
          icon: "face"
        };
      }
    }
  }
};
</script>
